
import React from "react";
import { Link } from "react-router-dom";
import "./style.css";

function Button({ text, className = "", to = null, onClick }) {
  const buttonClasses = `btn ${className}`;
  // const buttonClasses = `btn main-btn ${className}`;

  if (to) {
    return (
      <Link to={to} className={buttonClasses}>
        {text}
      </Link>
    );
  }

  return (
    <button type="button" className={buttonClasses} onClick={onClick}>
      {text}
    </button>
  );
}

export default Button;
